import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';

const HeaderSearchBar = ({ value, onChange, onClick }) => {
  return (
    <div className="flex flex-wrap justify-content-center gap-3 p-inputgroup search-container">
      <span className="p-input-icon-left p-input-icon-right search-wrapper">
        <i className="pi pi-search pt-18" />
        <InputText
          type="search"
          value={value || ''}
          onChange={onChange}
          placeholder="Search"
          className="search-input"
        />
        {value && (
          <Button
            icon="pi pi-times"
            className="p-button-secondary p-button-text cancel-button fs-13 clear-filter"
            onClick={onClick}
          />
        )}
      </span>
    </div>
  );
};

export default HeaderSearchBar;

